import { render, staticRenderFns } from "./CreateOrJoinSession.vue?vue&type=template&id=22341826&scoped=true"
import script from "./CreateOrJoinSession.vue?vue&type=script&lang=ts"
export * from "./CreateOrJoinSession.vue?vue&type=script&lang=ts"
import style0 from "./CreateOrJoinSession.vue?vue&type=style&index=0&id=22341826&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22341826",
  null
  
)

export default component.exports